import { render } from "./ForgotMyPassword.vue?vue&type=template&id=9f915a98"
import script from "./ForgotMyPassword.vue?vue&type=script&lang=js"
export * from "./ForgotMyPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__